import React from "react";

function LoadingSkeleton() {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      {/* Header Skeleton */}
      <header className="flex justify-between items-center bg-background p-4 border-b border-gray-100">
        <div className="font-bold text-2xl text-primary">RealignMind</div>
        <div className="hidden md:flex space-x-4">
          <div className="h-4 w-20 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
          <div className="h-4 w-16 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </header>

      {/* Main Content Skeleton */}
      <main className="flex-grow flex flex-col items-center justify-center p-8">
        {/* Centered loading indicator */}
        <div className="text-center">
          {/* Animated logo/spinner area */}
          <div className="mb-6">
            <div className="w-16 h-16 mx-auto rounded-full bg-gradient-to-r from-accent to-primary animate-pulse"></div>
          </div>
          
          {/* Loading text */}
          <p className="text-textSecondary text-lg mb-2">Loading your session tools...</p>
          <p className="text-textSecondary text-sm">This should only take a moment</p>
          
          {/* Progress bar */}
          <div className="mt-6 w-48 mx-auto">
            <div className="h-1 bg-gray-200 rounded-full overflow-hidden">
              <div className="h-full bg-accent rounded-full animate-loading-bar"></div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer Skeleton */}
      <footer className="bg-background border-t border-gray-100 p-4">
        <div className="max-w-screen-xl mx-auto flex justify-center">
          <div className="h-3 w-40 bg-gray-200 rounded animate-pulse"></div>
        </div>
      </footer>

      {/* Custom animation styles */}
      <style>{`
        @keyframes loading-bar {
          0% { width: 0%; margin-left: 0%; }
          50% { width: 60%; margin-left: 20%; }
          100% { width: 0%; margin-left: 100%; }
        }
        .animate-loading-bar {
          animation: loading-bar 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}

export default LoadingSkeleton;
